import { render, staticRenderFns } from "./DropdownFilter.vue?vue&type=template&id=ab4b8e4e&scoped=true&"
import script from "./DropdownFilter.vue?vue&type=script&lang=ts&"
export * from "./DropdownFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownFilter.vue?vue&type=style&index=0&id=ab4b8e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4b8e4e",
  null
  
)

export default component.exports